export const ALL_COLLATERAL_VALUE = [];
